export default __webpack_public_path__ + "static/media/Industrybusiness-min.353f2704.png";